<template>
	<div class="category-filter-list">
		<!-- 카테고리가 하나뿐일 때(화학물질): 카테고리 배지 + 태그 칩을 바로 보여준다. -->
		<div class="single-category" v-if="isSingle">
			<span class="category-badge">{{ singleCategory.name }}</span>
			<span class="divider"></span>
			<div class="tag-chips">
				<div class="chip" v-for="(item, index) in detailList" :key="`chip_${index}`">
					<input class="chip-input" type="checkbox" :id="`chip_${index}`" :value="item.value" v-model="checkedList" @change="checked" />
					<label :for="`chip_${index}`">{{ item.name }}</label>
				</div>
			</div>
		</div>
		<div class="category-filter" v-if="!isSingle">
			<div class="selected-category" v-if="statusNo > 1">
				<button class="prev-btn btn-common" @click="prev">
					<img src="@/assets/svg/prev-arrow_l.svg" />
				</button>
				<h6 @click="selectStep(1)">전체 카테고리</h6>
				<h6 @click="selectStep(2)">
					{{ activeCategory.name }}
				</h6>
			</div>
			<b v-else>총 {{ list.length }}개 카테고리</b>
		</div>
		<ul v-if="!isSingle && list.length > 0 && detailList.length === 0 && !activeCategory">
			<li v-for="(item, index) in list" :key="`category_${index}`" @click="selectParentCategory(item)">
				{{ item.name }}
			</li>
		</ul>
		<ul class="check-list" v-if="!isSingle && detailList.length > 0">
			<li v-for="(item, index) in detailList" :key="`item_${index}`">
				<input class="checkbox" type="checkbox" :id="`item_${index}`" :value="item.value" v-model="checkedList" @change="checked" />
				<label :for="`item_${index}`" v-b-tooltip.hover.top :title="item.name.length > 6 ? item.name : ''">
					{{ item.name }}
				</label>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'CategoryFilterList',
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		filtered: {
			type: Array,
			default: () => [],
		},
		selected: {
			type: Object,
			default: () => {},
		},
		isClassification: {
			type: Boolean,
			default: false,
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.checkedList = this.$route.query.tags ? [this.$route.query.tags] : []
		})
	},
	data() {
		return {
			activeCategory: null,
			detailList: [],
			statusNo: 1,
			checkedList: [],
			isInit: true,
			loadedCategory: null,
		}
	},
	computed: {
		...mapGetters('category', ['getChildCategoryList']),
		filterList() {
			return this.filtered
		},
		// 카테고리가 하나뿐이면(화학물질) 2단계 선택 대신 태그를 바로 보여준다.
		isSingle() {
			return this.list.length === 1
		},
		singleCategory() {
			return this.list[0]
		},
	},
	watch: {
		list: {
			immediate: true,
			handler(val) {
				// 목록 배열은 검색할 때마다 새로 만들어질 수 있어서, 같은 카테고리는 한 번만 불러온다.
				if (val.length === 1 && this.loadedCategory !== val[0].value) {
					this.loadedCategory = val[0].value
					this.loadSingleTags(val[0])
				}
			},
		},
		checkedList(val) {
			if (this.$_.isEmpty(val) && this.isInit && this.$route.query.tags) {
				this.isInit = false
				this.checkedList = [this.$route.query.tags]
				this.checked()
			}
		},
		filterList(val) {
			let values = []
			val.filter(filter => filter.type === 'tag').forEach(item => {
				values.push(item.value)
			})
			this.checkedList = values

			if (val.length == 0) {
				this.checkedList = []
			}

			let filteredParentCategory = this.filterList.filter(el => el.type === 'category' && el.node === 'parent')
			let filteredChildCategory = this.filterList.filter(el => el.type === 'category' && el.node === 'child')

			if (filteredParentCategory.length === 0) {
				this.statusNo = 1
			} else if (filteredChildCategory.length === 0) {
				this.statusNo = 2
			}
		},
		selected(newVal, oldVal) {
			if (newVal.value !== oldVal.value) this.selectParentCategory(newVal)
		},
		statusNo(val) {
			if (val === 2) {
				this.$emit('selectCategory', this.activeCategory)
			} else {
				this.$emit('selectCategory')
				this.activeCategory = null
				this.detailList = []
				this.checkedList = []
			}
		},
	},
	methods: {
		...mapActions('category', ['lookupChildCategoryList']),
		// 단일 카테고리: 태그 목록(표준품, 시약, 바이오 등)을 바로 불러온다.
		async loadSingleTags(category) {
			await this.lookupChildCategoryList(category.value)
			this.detailList = JSON.parse(JSON.stringify(this.getChildCategoryList))
		},
		async selectParentCategory(item) {
			if (this.isSingle) return
			this.activeCategory = item
			if (this.activeCategory.value) {
				this.statusNo = 2
				await this.setDetailList()
			}
		},
		async setDetailList() {
			let copyClassifcation = JSON.parse(JSON.stringify(this.activeCategory))
			await this.lookupChildCategoryList(this.activeCategory.value)
			this.activeCategory = copyClassifcation
			this.detailList = JSON.parse(JSON.stringify(this.getChildCategoryList))
		},
		prev() {
			if (this.statusNo > 0) {
				this.statusNo -= 1
			}
		},
		selectStep(step) {
			this.statusNo = step
		},
		checked() {
			this.$emit('checkCategory', this.checkedList)
		},
	},
}
</script>

<style lang="scss" scoped>
.category-filter-list {
	padding: 0 18px;
	/* 단일 카테고리(화학물질): 배지 + 태그 칩 */
	.single-category {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 14px;
		padding: 12px 0;
		.category-badge {
			display: inline-flex;
			align-items: center;
			height: 34px;
			padding: 0 18px;
			border-radius: 17px;
			background: #1d4f80;
			color: #fff;
			font-size: 0.9rem;
			font-weight: 700;
			letter-spacing: -0.01em;
		}
		.divider {
			width: 1px;
			height: 18px;
			background: #d9dee3;
		}
		.tag-chips {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			.chip {
				position: relative;
				.chip-input {
					position: absolute;
					opacity: 0;
					pointer-events: none;
				}
				label {
					display: inline-flex;
					align-items: center;
					height: 34px;
					padding: 0 16px;
					margin: 0;
					border: 1px solid #d6dde4;
					border-radius: 17px;
					background: #fff;
					color: #4a5764;
					font-size: 0.875rem;
					cursor: pointer;
					transition: all 0.15s ease-in-out;
					&:hover {
						border-color: #3d86c6;
						color: #1d4f80;
					}
				}
				.chip-input:checked + label {
					border-color: #3d86c6;
					background: #eaf3fb;
					color: #1d4f80;
					font-weight: 700;
				}
				.chip-input:focus-visible + label {
					outline: 2px solid #3d86c6;
					outline-offset: 2px;
				}
			}
		}
	}
	.category-filter {
		width: 100%;
		height: 50px;
		border-bottom: 1px solid $COLOR_DDD;
		display: flex;
		align-items: center;
		&.allSelected {
			border-bottom: 0;
		}
		b {
			font-size: 0.875rem;
			font-weight: 700;
		}
		.selected-category {
			width: 100%;
			display: flex;
			align-items: center;
			button {
				width: 30px;
				height: 30px;
				border-radius: 4px;
				margin-right: 10px;
				img {
					width: 24px;
					height: 24px;
				}
			}
			h6 {
				display: inline-block;
				padding-right: 22px;
				background-image: url(~@/assets/svg/arrow_up_s.svg);
				background-repeat: no-repeat;
				background-size: 7px;
				background-position: center right 6px;
				cursor: pointer;
				&:last-child {
					background-image: none;
					cursor: default;
					&:hover {
						text-decoration: unset;
					}
				}
				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
	ul {
		display: block;
		width: 100%;
		padding-bottom: 15px;
		li {
			width: calc(100% / 6);
			font-size: 0.875rem;
			font-weight: 400;
			display: inline-block;
			margin-top: 10px;
			cursor: pointer;
			&:hover {
				text-decoration: underline;
			}
		}
	}
	.check-list {
		width: calc(100% + 10px);
		text-align: left;
		padding-bottom: 10px;
		li {
			display: inline-flex;
			width: 138px;
			margin-right: 10px;
			position: relative;
			align-items: center;
			height: 20px;
			label {
				@include ellipse;
				display: inline-block;
				font-size: 0.875rem;
				font-weight: 400;
				margin-left: 10px;
				max-width: calc(100% - 30px);
				cursor: pointer;
				position: relative;
				cursor: pointer;
			}
			label:hover ~ .tooltip {
				display: block;
				visibility: visible;
				opacity: 1;
			}
		}
	}
}
</style>
